import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { validate, validatorFromFunction, validators, combine } from 'validate-redux-form';
import { renderField, renderTextArea, renderAntDatePicer } from '../../../Utils/renderField';
import { Link, Redirect } from 'react-router-dom';
import  {renderDropdownDateField} from "../../../Utils/renderField/otherrenders";


const SeriesForm = (props) => {
    const { handleSubmit, pristine, reset, submitting } = props;

    const onlyLetras = value => {
        if (!value) return value;
        const limpio = value.replace(/[^a-zA-Z]/g, '');
        return limpio.slice(0, 1).toUpperCase();
    };

    return (
        <form name="SeriesForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
            <div className="row justify-content-center">
                <div className="form-group has-feedback col-md-6 col-12">
                    <label className="t-azul" htmlFor="prefix">Serie Recibo de Caja</label>
                    <Field
                        name="prefix"
                        label="prefix"
                        component={renderField}
                        type="text"
                        className="form-control"
                        maxlength={1}
                        placeholder='Serie'
                        parse={onlyLetras}
                    />
                </div>
            </div>
            <div className="row justify-content-sm-around justify-content-center">
                <Link className="btn btn-secondary m-1 align-self-center" to="/usuarios">CANCELAR</Link>
                <button type="submit" className="btn btn-primary m-1 align-self-center">GUARDAR</button>
            </div>
        </form>
    );
};


export default reduxForm({
    form: 'SeriesForm', // a unique identifier for this form
    // enableReinitialize: true,
    validate: (data) => {
        return validate(data, {
            prefix: validators.exists()('Este campo es requerido'),
        });
    },
})(SeriesForm);
